export const CONTACT_DEFAULTS = {
  email: 'hello@nayavarnam.com',
  hours: '10am – 7pm IST',
  address: '',
};
